module.exports = __webpack_public_path__ + "static/media/main-event-decorator.76b7c346.svg";